module.exports = __webpack_public_path__ + "Lifestyle Spending Account FAQ.pdf";